// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.externaltour.ListingExternalTourType

export enum ListingExternalTourType {
  FEED_PROVIDED = 'FEED_PROVIDED',
  INTEGRATION = 'INTEGRATION',
  ZRM = 'ZRM',
}

export const ListingExternalTourType_values = [
  ListingExternalTourType.FEED_PROVIDED,
  ListingExternalTourType.INTEGRATION,
  ListingExternalTourType.ZRM,
] as const;
